module.exports = __webpack_public_path__ + "static/media/6730.73991c94.jpg";